export default "__VITE_ASSET__D9Ktm5oC__"